#import "~/graphql/fragments/sections/default/baseEntryFields.graphql"
#import "~/graphql/fragments/assets/image.graphql"

fragment projectPreview on project_Entry {
    ... baseEntryFields
    featuredImage {
        ... image
    }
    shortDescription
}
